import * as THREE from 'three';
export const PAS_FOR_ROAD = 550
export const HEIGHT_FOR_ROAD = 550
export const material = new THREE.MeshBasicMaterial();
export const material2 = new THREE.MeshBasicMaterial();
export const material3 = new THREE.MeshBasicMaterial();
export const material4 = new THREE.MeshBasicMaterial();

const materials = [material, material2, material3, material4]
const textur_loader = new THREE.TextureLoader();
textur_loader.load( `/game/datas/textures/road.png`, ( texture )=>{    
    material.map = texture;
    material.needsUpdate = true;
    material.wrapS = THREE.RepeatWrapping;
    material.WrapT = THREE.RepeatWrapping;
    material.transparent = true;
});
const textur_loader2 = new THREE.TextureLoader();
textur_loader2.load( `/game/datas/textures/road-v1.png`, ( texture )=>{    
    material2.map = texture;
    material2.needsUpdate = true;
    material2.wrapS = THREE.RepeatWrapping;
    material2.WrapT = THREE.RepeatWrapping;
    material2.transparent = true;
});

const textur_loader3 = new THREE.TextureLoader();
textur_loader3.load( `/game/datas/textures/road-v2.png`, ( texture )=>{    
    material3.map = texture;
    material3.needsUpdate = true;
    material3.wrapS = THREE.RepeatWrapping;
    material3.WrapT = THREE.RepeatWrapping;
    material3.transparent = true;
});

const textur_loader4 = new THREE.TextureLoader();
textur_loader4.load( `/game/datas/textures/road-v3.png`, ( texture )=>{    
    material4.map = texture;
    material4.needsUpdate = true;
    material4.wrapS = THREE.RepeatWrapping;
    material4.WrapT = THREE.RepeatWrapping;
    material3.transparent = true;
});
//Help.drawRoad from:  Kc {lng: 43.34806803372027, lat: 22.549953663495373} Kc {lng: 43.35532629917816, lat: 22.5522134152107}
//Roads.mousemo from:  Kc {lng: 43.34806803372027, lat: 22.549953663495373} Kc {lng: 43.35532629917816, lat: 22.5522134152107}


let current_material = null

const getMateriel = ()=>{
    let k = materials.length*Math.random(materials.length)
    let nn = Math.floor(k)

    if(!current_material){
        current_material = materials[nn]
    }
    //console.log("getMateriel", k, nn)
    return current_material
}

export const getMinDistance = (f, vectors)=>{

    
    let r= 100000000000000

    for(let i=0; i < vectors.length; i ++){
        let v = f.sub(vectors[i])
        if( v.length() < r){
            r =  v.length()
        }
    }

    return r
}
export const drawRoadLine = (scene3D, road, line, position) =>{
    
    const {x: x1, y:y1, z:z1} = scene3D.map.getPosition3D(line.begin.lngLat)
    const {x: x2, y:y2, z:z2} = scene3D.map.getPosition3D(line.end.lngLat)
    let v = new THREE.Vector3( (x1 -x2), (y1 -y2), (z1 -z2))
    const r = v.length()
    v = v.normalize()
    if(position === undefined) position = 0
    if(!isNaN(v.z)){ 

        let pas = PAS_FOR_ROAD
        if(pas > r) pas = r

        const height = HEIGHT_FOR_ROAD
        let step = pas > 0 ? Math.floor(r/pas) : 0

        if(step*PAS_FOR_ROAD < r) {
            const last = r - step*PAS_FOR_ROAD
            pas += 1 + Math.floor(last/step)
        }
        if(line.trash){
            for(var i=0; i < line.trash.length; i ++){
                scene3D.scene.remove(line.trash[i]);
            }
            
        }
        line.shaps = []
        line.trash = []


        let {x: x, y:y, z:z} = scene3D.map.getPosition3D(line.begin.lngLat)

        for(let i=0; i < step; i ++){
            const geo = new THREE.PlaneGeometry( pas, height, 20, 20);
            geo.rotateX(-Math.PI / 2)


            const plane = new THREE.Mesh(geo, getMateriel());
            plane.position.set(x - (v.x*pas/2), position, z - (v.z*pas/2))
            plane.origine = new THREE.Vector3( x, 0 , z)

            console.log("position", position)
            
            scene3D.scene.add(plane);
            
            if(i >= 0 && line.controle){ 
                let axesHelper = new THREE.AxesHelper(60);
                axesHelper.scale.set(5, 5, 5)
                axesHelper.position.set(x, 0, z)
                scene3D.scene.add(axesHelper);
                line.trash.push(axesHelper)
            }

            x += -v.x*pas
            z += -v.z*pas

            line.shaps.push(plane)
            line.trash.push(plane)
        }

        if(line.shaps.length > 1){
            const p1 = line.shaps[0].origine
            const p2 = line.shaps[1].origine 
            let w = p1.clone().sub(p2).normalize()
            
            let o = ((Math.PI/2) - w.angleTo(new THREE.Vector3( 0,0,1)))
            if(w.x >= 0){
                o = -o
            }

            for(var i=0; i < line.shaps.length; i ++){
                line.shaps[i].rotateY(o)
            }
        }

        if(line.select === true){
            const v2 = new THREE.Vector3(x2 , y2, z2)
            const v1 = new THREE.Vector3(x1, y1, z1)
            
            const geom = new THREE.SphereGeometry( PAS_FOR_ROAD/4, 32, 16 ); 
            const mm = new THREE.MeshPhongMaterial( { color: 0xffff00 } ); 
            let sphere = new THREE.Mesh( geom, mm ); 
            sphere.receiveShadow = true;
            sphere.name = "sphere-begin"
            sphere.position.set(v1.x, v1.y + 100, v1.z )

            console.log("position", position)
            scene3D.scene.add( sphere );
            if(line.focus === "end"){
                sphere.scale.set(0.5, 0.5, 0.5)
                
            }
            else if(line.focus === "begin"){
                sphere.scale.set(1.5, 1.5, 1.5)
            }

            line.trash.push(sphere)

            sphere = new THREE.Mesh( geom, mm ); 
            sphere.receiveShadow = true;
            sphere.name = "sphere-end"
            sphere.position.set(v2.x , v2.y + 100, v2.z)
            scene3D.scene.add( sphere );
            if(line.focus === "begin"){
                
                sphere.scale.set(0.5, 0.5, 0.5)
            }else if(line.focus === "end"){
                sphere.scale.set(1.5, 1.5, 1.5)
            }

            line.trash.push(sphere)
        } else if(line.focus === "begin" || line.focus === "end" ){
            const v2 = new THREE.Vector3(x2 , y2, z2)
            const v1 = new THREE.Vector3(x1, y1, z1)

            const geom = new THREE.SphereGeometry( PAS_FOR_ROAD/4, 32, 16 ); 
            const mm = new THREE.MeshPhongMaterial( { color: 0xffff00 } ); 
            let sphere = new THREE.Mesh( geom, mm ); 
            sphere.receiveShadow = true;
            
            if(line.focus === "begin"){
                sphere.name = "sphere-begin"
                sphere.position.set(v1.x, v1.y + 100, v1.z )
            } else{
                sphere.name = "sphere-end"
                sphere.position.set(v2.x , v2.y + 100, v2.z)
            }

            console.log("position", position)

            if(!line.focusAnimation){
                const keys = [0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15]
                line.keyPos = 0
                line.focusAnimation = setInterval(()=>{
                    
                    if(!line.focus || line.select){
                        clearInterval(line.focusAnimation)
                        line.focusAnimation = undefined
                        scene3D.scene.remove(sphere);
                        return
                    }
                    sphere.scale.set(1 + keys[line.keyPos], 1 + keys[line.keyPos], 1 + keys[line.keyPos])
                    line.keyPos += 1
                    if(line.keyPos >= keys.length){
                        line.keyPos = 0
                    }

                   //console.log("animation", line.keyPos, line.focus)
                    scene3D.scene.remove(sphere);
                    scene3D.scene.add(sphere);
                    
                }, 50)
            }
            line.trash.push(sphere)
            scene3D.scene.add( sphere );
        }
    }

}

export const drawRoadFromTo = (scene3D, begin, end, trash, position=50) =>{
    
    const {x: x1, y:y1, z:z1} = scene3D.map.getPosition3D(begin.lngLat)
    const {x: x2, y:y2, z:z2} = scene3D.map.getPosition3D(end.lngLat)
    let v = new THREE.Vector3( (x1 -x2), (y1 -y2), (z1 -z2))
    const r = v.length()
    v = v.normalize()
    if(!isNaN(v.z)){ 

        const shaps = []
        let pas = PAS_FOR_ROAD
        if(pas > r) pas = r

        const height = HEIGHT_FOR_ROAD
        let step = pas > 0 ? Math.floor(r/pas) : 0

        if(step*PAS_FOR_ROAD < r) {
            const last = r - step*PAS_FOR_ROAD
            pas += 1 + Math.floor(last/step)
        }
        let {x: x, y:y, z:z} = scene3D.map.getPosition3D(begin.lngLat)

        for(let i=0; i < step; i ++){
            const geo = new THREE.PlaneGeometry( pas, height, 20, 20);
            geo.rotateX(-Math.PI / 2)

            const plane = new THREE.Mesh(geo, getMateriel());
            plane.position.set(x - (v.x*pas/2), position, z - (v.z*pas/2))
            plane.origine = new THREE.Vector3( x, 0 , z)

            scene3D.scene.add(plane);
            
            
            x += -v.x*pas
            z += -v.z*pas

            shaps.push(plane)
            trash.push(plane)
        }

        if(shaps.length > 1){
            const p1 = shaps[0].origine
            const p2 = shaps[1].origine 
            let w = p1.clone().sub(p2).normalize()
            
            let o = ((Math.PI/2) - w.angleTo(new THREE.Vector3( 0,0,1)))
            if(w.x >= 0){
                o = -o
            }

            for(var i=0; i < shaps.length; i ++){
                shaps[i].rotateY(o)
            }
        }

        //manageSelection (scene3D, begin, trash)
        //manageSelection (scene3D, end, trash)
    }
}

export const manageSelection = (scene3D, point) => {
    const {x: x, y:y, z:z} = scene3D.map.getPosition3D(point.lngLat)
    const v = new THREE.Vector3(x, y, z)
    const must = point.select || point.focus || point.animate

    if(!must){
        if(point.sphere){
            scene3D.scene.remove(point.sphere);
            point.sphere = null
        }
    }
    else{
        if(point.select){
            point.animate = false
        }
    }
    if(!point.sphere && (must)){ 
        const geom = new THREE.SphereGeometry( PAS_FOR_ROAD/4, 32, 16 ); 
        const mm = new THREE.MeshPhongMaterial( { color: 0xffff00 } ); 
        let sphere = new THREE.Mesh( geom, mm ); 
        sphere.receiveShadow = true;
        sphere.position.set(v.x, v.y + 100, v.z )
        scene3D.scene.add( sphere );
        sphere.name = `sphere-${point.uid}`
        point.sphere = sphere
        
    }
    else if(point.sphere) {
        
        point.sphere.position.set(v.x, v.y + 100, v.z )
        scene3D.scene.remove(point.sphere);
        scene3D.scene.add(point.sphere);
    }
    if(point.focus){
        point.sphere.scale.set(1.5, 1.5, 1.5)
    }
    
    if(point.animate){
        const keys = [0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15]
        
        if(point.keyPos === undefined){
            point.keyPos = 0;
        }
        point.sphere.scale.set(1 + keys[point.keyPos], 1 + keys[point.keyPos], 1 + keys[point.keyPos])
        point.keyPos += 1
        if(point.keyPos >= keys.length){
            point.keyPos = 0
        }
        scene3D.scene.remove(point.sphere);
        scene3D.scene.add(point.sphere);
    }
}

export const drawRoad = (scene3D, road, position) =>{
    
    for(let n=0; n< road.segments.length; n ++)
    {
        const line = road.segments[n]
        drawRoadLine(scene3D, road, line, n)
    }

}

export const drawRoads = (scene3D, roads) =>{
    console.log("Help.drawRoads", roads)
    for(let i=0; i< roads.length; i ++){
        drawRoad(scene3D, roads[i], i)
    }
}

export const getBoundingRec = (scene) =>{
   let box
    let boxSize = -100
    let boundingRects = []
    scene.traverse( function ( child ){
        if ( child.isMesh )
        {
        const b = new THREE.Box3().setFromObject(child);
        boundingRects.push(b)
        const s = b.getSize(new THREE.Vector3()).length();
        if(s > boxSize){
            boxSize = s
            box = b
        }
        
        }
    });

    if(box){
        scene.scale.set(1/boxSize, 1/boxSize, 1/boxSize)
        const v = box.getCenter(new THREE.Vector3())
        scene.position.set(-v.x/boxSize, -v.y/boxSize, -v.z/boxSize)
        return {
            boundingRects: boundingRects,
            boundingRect: box
        } 
    }
    return  {}
}
